










import { Component, Vue, Prop } from "vue-property-decorator";
import { UploaderService } from "@/services/cdn/uploader.service";
import { ResultUploader } from "@/models/uploaders/result.uploader";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { ImageUploader } from "@/models/uploaders/image.uploader";

@Component
export default class SingleImageUploaderComponent extends Vue {
  @Prop() label?: string;
  @Prop() folder?: string;
  isLoading: boolean = false;
  uploadService: UploaderService = new UploaderService();

  onSelect(file?: File): void {
    if (this.isLoading) return;
    this.isLoading = true;
    if (file) {
      const model = new ImageUploader();
      model.folder = this.folder || null;
      model.image = file;
      this.uploadService
        .UploadSinglePhoto(model)
        .then((response: ResultUploader) => {
          if (response.processed) {
            this.$emit("select", response.path);
          } else {
            NotificationServiceBus.showErrorMessage(
              "Erro",
              "O ficheiro não é uma imagem válida"
            );
          }
        })
        .catch(() =>
          NotificationServiceBus.showErrorMessage(
            "Erro",
            "Não foi possível enviar o ficheiro para o servidor"
          )
        )
        .finally(() => (this.isLoading = false));
    } else {
      this.isLoading = false;
      this.$emit("select", []);
    }
  }
}
